import React, { useState } from "react";
import {
  Modal,
  Box,
  Button,
  TextField,
  MenuItem,
  Grid,
  IconButton,
  Typography,
  Autocomplete,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import { get, postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import AddIcon from "@mui/icons-material/Add";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import { whiteColor } from "../../theme/setThemeColor";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%", // previously 35%
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  borderRadius: "8px",
};

export default function AddDeveloperLeave({ refresh }) {
  const [open, setOpen] = useState(false);
  const [selectedDeveloper, setSelectedDeveloper] = useState(null);
  const [developers, setDevelopers] = useState([]);
  const [request, setRequest] = useState(false);

  const { control, handleSubmit, setValue, reset } = useForm();

  const handleOpen = () => {
    setOpen(true);
    getDeveloper();
  };

  const handleClose = () => {
    setOpen(false);
    reset(); // Reset all form data
    setSelectedDeveloper(null); // Reset developer state
  };

  const getDeveloper = () => {
    postJsonData(
      `${ApiEndpoints.GET_USERS_NAME}?role=EMPLOYEE`,
      "",
      setRequest,
      (res) => {
        setDevelopers(res.data || []);
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };

  const handleDeveloperChange = (e) => {
    const devId = parseInt(e.target.value);
    const dev = developers.find((d) => d.id === devId);
    setSelectedDeveloper(dev);
    setValue("developer_id", dev?.id || ""); // Set the developer ID
  };

  const onSubmit = (data) => {
    const payload = {
      ...data,
      user_id: selectedDeveloper?.id,
    };

    postJsonData(
      ApiEndpoints.CREATE_LEAVE,
      { ...payload },
      setRequest,
      (res) => {
        okSuccessToast(res.data.message);
        if (refresh) refresh();
        handleClose();
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  return (
    <div>
      <Button
        startIcon={
          <IconButton sx={{ p: 0, color: whiteColor() }}>
            <AddCircleOutlineIcon />
          </IconButton>
        }
        size="small"
        color="success"
        variant="contained"
        sx={{
          padding: 1,
          backgroundColor: "#2F3B57",
          borderRadius: "2px",
          color: whiteColor(),
        }}
        onClick={handleOpen}
      >
        Add Leave
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={{ ...style, maxHeight: "90vh", overflowY: "auto" }}>
          <ModalHeader title="Add Developer Leave" handleClose={handleClose} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
              name="developer"
              control={control}
              defaultValue={null}
              rules={{ required: "Please select a developer" }}
              render={({ field, fieldState }) => (
                <Autocomplete
                  options={developers}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    developers.find((dev) => dev.id === field.value) || null
                  }
                  onChange={(event, newValue) => {
                    field.onChange(newValue ? newValue.id : null);
                    setSelectedDeveloper(newValue || null);
                    setValue("developer_id", newValue?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Developer"
                      margin="normal"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
              )}
            />

            <Controller
              name="developer_id"
              control={control}
              defaultValue=""
              rules={{ required: "Developer ID is required" }}
              render={({ field, fieldState }) => (
                <TextField
                  label="Developer ID"
                  fullWidth
                  margin="normal"
                  disabled
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  {...field}
                />
              )}
            />

            {/* <Typography mt={2} fontWeight={600}>
              Leave Counts
            </Typography> */}
            <Grid container spacing={2} mt={1}>
              {["cl", "sl", "compensatory", "el", "ml", "pl", "bl"].map(
                (fieldName) => (
                  <Grid item xs={6} key={fieldName}>
                    <Controller
                      name={fieldName}
                      control={control}
                      defaultValue={0}
                      rules={{
                        required: `${fieldName.toUpperCase()} is required`,
                      }}
                      render={({ field, fieldState }) => (
                        <TextField
                          label={fieldName.toUpperCase()}
                          type="number"
                          fullWidth
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                          {...field}
                        />
                      )}
                    />
                  </Grid>
                )
              )}
            </Grid>

            <Grid container spacing={2} mt={1}>
              {[
                "total_cl",
                "total_sl",
                "total_compensatory",
                "total_el",
                "total_ml",
                "total_pl",
                "total_bl",
              ].map((fieldName) => (
                <Grid item xs={6} key={fieldName}>
                  <Controller
                    name={fieldName}
                    control={control}
                    defaultValue=""
                    rules={{
                      required: `${fieldName.toUpperCase()} is required`,
                    }}
                    render={({ field, fieldState }) => (
                      <TextField
                        label={fieldName.toUpperCase()}
                        type="number"
                        fullWidth
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        {...field}
                      />
                    )}
                  />
                </Grid>
              ))}
            </Grid>

            <Box mt={3}>
              <ModalFooter btn="Submit" onClick={handleSubmit(onSubmit)} />
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
